var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast"},[_c('div',{staticClass:"toast-content",class:{
      show: _vm.show,
      scale: _vm.scale,
      [_vm.position]: _vm.position,
      [_vm.positionClass]: _vm.positionClass,
    }},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }